const ITEMS = [
  "Busca e apreensão",
  "Alienação fiduciária",
  "Execução de título extrajudicial",
  "Ação monitória",
  "Agronegócio",
  "Negociação bancária",
];

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {ITEMS.map((t) => (
      <span key={t} className="flex items-center">
        <span className="font-display italic text-4xl md:text-6xl text-[#E6C687]/90 px-8 md:px-12 whitespace-nowrap">{t}</span>
        <svg viewBox="0 0 10 10" className="w-3 h-3 fill-[#D4AF37]"><path d="M5 0l1.2 3.8L10 5 6.2 6.2 5 10 3.8 6.2 0 5l3.8-1.2z" /></svg>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="editorial-marquee" className="relative border-y border-[#D4AF37]/15 py-8 md:py-10 overflow-hidden bg-[#080E21]">
    <div className="flex w-max animate-marquee">
      <Row />
      <Row hidden />
    </div>
  </section>
);
